// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"OtherExchangesList_emptyMessage__2BuUS","exchanges":"OtherExchangesList_exchanges__1m0Rw","exchangeItem":"OtherExchangesList_exchangeItem__1Oafa"};